// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	NewProjects: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "NewProjects" */
				'./index'
			),
	} ),
};
